module.exports = __webpack_public_path__ + "3e90920ea692b78e89a240d18124683a.pdf";